var map = {
	"./demos/basic/index.ts": 44715,
	"./demos/content/index.ts": 44094,
	"./demos/overlay/index.ts": 33715,
	"./demos/placement/index.ts": 64982,
	"./demos/resizable/index.ts": 90723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47423;